(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_menu"] && !Shopify.designMode) return;
  try {
    
  function initMegaMenus() {
    const megaMenus = document.querySelectorAll('.mm-section');
    const headerElement = document.querySelector('header') || document.querySelector('.header-wrapper') || document.querySelector('#shopify-section-header');
    
    megaMenus.forEach(menu => {
      const triggerText = menu.getAttribute('data-trigger');
      if (!triggerText) return;

      // Search for links strictly inside the header to avoid accidentally targeting page content elsewhere
      const navLinks = document.querySelectorAll('header a, header summary, .header-wrapper a, .header-wrapper summary');
      
      const positionMenu = (link) => {
        if (headerElement) {
          const headerRect = headerElement.getBoundingClientRect();
          menu.style.top = headerRect.bottom + 'px';
          
          // Align under the navigation link
          const linkRect = link.getBoundingClientRect();
          let expectedLeft = linkRect.left - 30; // Shift left slightly to look balanced
          
          const menuWidth = menu.offsetWidth;
          // Ensure it doesn't overflow off the right side of the screen
          if (expectedLeft + menuWidth > window.innerWidth - 20) {
            expectedLeft = window.innerWidth - menuWidth - 20;
          }
          // Ensure it doesn't overflow off the left side of the screen
          if (expectedLeft < 20) {
            expectedLeft = 20;
          }
          
          menu.style.left = expectedLeft + 'px';
        }
      };

      navLinks.forEach(link => {
        if (link.textContent.trim().toLowerCase() === triggerText) {
          const parentItem = link.closest('li') || link.parentElement;
          
          if (!parentItem.classList.contains('mm-has-dropdown')) {
            parentItem.classList.add('mm-has-dropdown');
            
            // 1. DESKTOP LOGIC (Hover)
            let timeoutId;
            const openMenu = () => { 
              if (window.innerWidth > 900) { 
                clearTimeout(timeoutId);
                // Only reposition if the link is actually visible on screen
                if (link.offsetWidth > 0 && link.offsetHeight > 0) {
                  positionMenu(link); 
                }
                menu.classList.add('is-open'); 
              } 
            };
            const closeMenu = () => { 
              if (window.innerWidth > 900) {
                timeoutId = setTimeout(() => {
                  menu.classList.remove('is-open');
                }, 150); // 150ms delay gives time to move mouse to the menu
              }
            };

            parentItem.addEventListener('mouseenter', openMenu);
            parentItem.addEventListener('mouseleave', closeMenu);
            menu.addEventListener('mouseenter', openMenu);
            menu.addEventListener('mouseleave', closeMenu);

            // 2. MOBILE LOGIC (Inject Accordion & Arrow)
            // Create toggle arrow
            const arrow = document.createElement('button');
            arrow.className = 'mm-mobile-toggle';
            arrow.setAttribute('aria-label', 'Toggle Dropdown');
            arrow.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>';
            
            // Place arrow directly after the link
            link.insertAdjacentElement('afterend', arrow);

            // Clone the columns to form the accordion body
            const accordionBody = document.createElement('div');
            accordionBody.className = 'mm-accordion-body';
            
            // Grab the columns from the main menu
            const columns = menu.querySelectorAll('.mm-column');
            columns.forEach(col => {
              accordionBody.appendChild(col.cloneNode(true));
            });

            // Append accordion body inside the list item
            parentItem.appendChild(accordionBody);

            // Arrow click toggles accordion
            arrow.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              accordionBody.classList.toggle('is-expanded');
              arrow.classList.toggle('is-active');
            });
          }
        }
      });
    });
  }

  // Run on load and periodically to combat theme JS rebuilding the mobile menu
  document.addEventListener('DOMContentLoaded', initMegaMenus);
  document.addEventListener('shopify:section:load', initMegaMenus);
  setInterval(initMegaMenus, 1000);
  window.addEventListener('resize', () => {
    document.querySelectorAll('.mm-section.is-open').forEach(menu => {
       const headerElement = document.querySelector('header') || document.querySelector('.header-wrapper');
       if (headerElement && window.innerWidth > 900) {
          menu.style.top = headerElement.getBoundingClientRect().bottom + 'px';
          
          // Re-position left if open during resize
          const triggerText = menu.getAttribute('data-trigger');
          const navLinks = document.querySelectorAll('header a, header summary, .header-wrapper a, .header-wrapper summary');
          navLinks.forEach(link => {
            if (link.textContent.trim().toLowerCase() === triggerText) {
              const linkRect = link.getBoundingClientRect();
              let expectedLeft = linkRect.left - 30;
              const menuWidth = menu.offsetWidth;
              if (expectedLeft + menuWidth > window.innerWidth - 20) expectedLeft = window.innerWidth - menuWidth - 20;
              if (expectedLeft < 20) expectedLeft = 20;
              menu.style.left = expectedLeft + 'px';
            }
          });
       }
       if (window.innerWidth <= 900) menu.classList.remove('is-open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const pabSection = document.querySelector('.pab-section');
    if (!pabSection) return;

    // Handle Close Button
    const closeBtn = pabSection.querySelector('.pab-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        pabSection.style.marginTop = `-${pabSection.offsetHeight}px`;
        pabSection.style.opacity = '0';
        setTimeout(() => {
          pabSection.style.display = 'none';
        }, 300); // Wait for transition
      });
    }

    // Handle Slider
    const slider = pabSection.querySelector('.pab-slider');
    if (!slider) return;

    const messages = slider.querySelectorAll('.pab-message');
    const count = parseInt(slider.getAttribute('data-block-count'), 10);
    
    if (count > 1) {
      let currentIndex = 0;
      
      setInterval(() => {
        // Fade out current
        messages[currentIndex].classList.remove('is-active');
        
        // Move to next
        currentIndex = (currentIndex + 1) % count;
        
        // Fade in new
        messages[currentIndex].classList.add('is-active');
      }, 4000); // 4 seconds per message
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
